"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tvl = exports.withdraw = exports.deposit = exports.refreshReserveIx = exports.setHashes = exports.initializeProtocol = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const buffer_layout_1 = __importDefault(require("buffer-layout"));
const sha256_uint8array_1 = require("sha256-uint8array");
const addressParser_1 = require("../addressParser");
const protocols_1 = require("../protocols");
const portKeysAll = (0, addressParser_1.addressParser)({
    group: "protocols",
    name: "port",
});
function initializeProtocol(program) {
    return __awaiter(this, void 0, void 0, function* () {
        const tokenInput = program.tokenInput;
        const vaultKeys = program.vaultKeys[tokenInput];
        const portKeys = portKeysAll[tokenInput];
        const vaultPortCollateralTokenAccount = yield (0, spl_token_1.getAssociatedTokenAddress)(portKeys.reserveCollateralMintAccount, vaultKeys.vaultAccount, true);
        vaultKeys.vaultPortCollateralTokenAccount = vaultPortCollateralTokenAccount;
        if (yield program.connection.getAccountInfo(vaultPortCollateralTokenAccount)) {
            console.log("port accounts already initialized");
            return null;
        }
        else {
            const tx = new anchor_1.web3.Transaction();
            tx.add((0, spl_token_1.createAssociatedTokenAccountInstruction)(program.user, vaultPortCollateralTokenAccount, vaultKeys.vaultAccount, portKeys.reserveCollateralMintAccount));
            return tx;
        }
    });
}
exports.initializeProtocol = initializeProtocol;
function setHashes(program) {
    return __awaiter(this, void 0, void 0, function* () {
        const tokenInput = program.tokenInput;
        const vaultKeys = program.vaultKeys[tokenInput];
        const portKeys = portKeysAll[tokenInput];
        const depositData = new Uint8Array([
            ...vaultKeys.vaultPortCollateralTokenAccount.toBytes(),
            ...portKeys.reserveAccount.toBytes(),
            ...portKeys.reserveLiquiditySupplyAccount.toBytes(),
            ...portKeys.reserveCollateralMintAccount.toBytes(),
            ...portKeys.lendingMarketAccount.toBytes(),
            ...portKeys.lendingMarketAuthorityAccount.toBytes(),
        ]);
        const withdrawData = new Uint8Array([
            ...vaultKeys.vaultPortCollateralTokenAccount.toBytes(),
            ...portKeys.reserveAccount.toBytes(),
            ...portKeys.reserveLiquiditySupplyAccount.toBytes(),
            ...portKeys.reserveCollateralMintAccount.toBytes(),
            ...portKeys.lendingMarketAccount.toBytes(),
            ...portKeys.lendingMarketAuthorityAccount.toBytes(),
        ]);
        const tvlData = new Uint8Array([
            ...portKeys.reserveAccount.toBytes(),
            ...vaultKeys.vaultPortCollateralTokenAccount.toBytes(),
        ]);
        const HASH_LEN = 16;
        const hashes = [
            (0, sha256_uint8array_1.createHash)().update(depositData).digest().slice(0, HASH_LEN),
            (0, sha256_uint8array_1.createHash)().update(withdrawData).digest().slice(0, HASH_LEN),
            (0, sha256_uint8array_1.createHash)().update(tvlData).digest().slice(0, HASH_LEN),
        ];
        return program.methods
            .setHashes(protocols_1.Protocols.Port, hashes)
            .accounts({
            userSigner: program.user,
            vaultAccount: vaultKeys.vaultAccount,
        })
            .transaction();
    });
}
exports.setHashes = setHashes;
const refreshReserveIx = (tokenInput) => {
    const portKeys = portKeysAll[tokenInput];
    let oracle = "";
    if (tokenInput !== "USDC") {
        oracle = portKeys.oracleAccount;
    }
    return refreshReserveInstruction({
        programId: portKeys.lendingProgramId,
        reserve: portKeys.reserveAccount,
        oracle,
    });
};
exports.refreshReserveIx = refreshReserveIx;
const refreshReserve = 3;
// https://docs.rs/port-variable-rate-lending-instructions/0.2.4/src/port_variable_rate_lending_instructions/instruction.rs.html#411
function refreshReserveInstruction({ programId, reserve, oracle }) {
    const DataLayout = buffer_layout_1.default.struct([buffer_layout_1.default.u8("instruction")]);
    const data = Buffer.alloc(DataLayout.span);
    DataLayout.encode({ instruction: refreshReserve }, data);
    const keys = [
        { pubkey: reserve, isSigner: false, isWritable: true },
        {
            pubkey: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
            isSigner: false,
            isWritable: false,
        },
    ];
    if (oracle.length != "") {
        keys.push({ pubkey: oracle, isSigner: false, isWritable: false });
    }
    return new anchor_1.web3.TransactionInstruction({
        keys,
        programId,
        data,
    });
}
function deposit(program, genericAcccounts) {
    const tokenInput = program.tokenInput;
    const vaultKeys = program.vaultKeys[tokenInput];
    const portKeys = portKeysAll[tokenInput];
    return program.methods
        .portDeposit()
        .accounts({
        genericAccs: genericAcccounts,
        portLendingProgramId: portKeys.lendingProgramId,
        vaultPortCollateralTokenAccount: vaultKeys.vaultPortCollateralTokenAccount,
        portReserveAccount: portKeys.reserveAccount,
        portReserveLiquiditySupplyAccount: portKeys.reserveLiquiditySupplyAccount,
        portReserveCollateralMintAccount: portKeys.reserveCollateralMintAccount,
        portLendingMarketAccount: portKeys.lendingMarketAccount,
        portLendingMarketAuthorityAccount: portKeys.lendingMarketAuthorityAccount,
    })
        .preInstructions([(0, exports.refreshReserveIx)(tokenInput)])
        .transaction();
}
exports.deposit = deposit;
function withdraw(program, genericAcccounts) {
    return __awaiter(this, void 0, void 0, function* () {
        return withdrawBuilder(program, genericAcccounts).transaction();
    });
}
exports.withdraw = withdraw;
function withdrawBuilder(program, genericAcccounts) {
    const tokenInput = program.tokenInput;
    const vaultKeys = program.vaultKeys[tokenInput];
    const portKeys = portKeysAll[tokenInput];
    return program.methods
        .portWithdraw()
        .accounts({
        genericAccs: genericAcccounts,
        portLendingProgramId: portKeys.lendingProgramId,
        vaultPortCollateralTokenAccount: vaultKeys.vaultPortCollateralTokenAccount,
        portReserveAccount: portKeys.reserveAccount,
        portReserveLiquiditySupplyAccount: portKeys.reserveLiquiditySupplyAccount,
        portReserveCollateralMintAccount: portKeys.reserveCollateralMintAccount,
        portLendingMarketAccount: portKeys.lendingMarketAccount,
        portLendingMarketAuthorityAccount: portKeys.lendingMarketAuthorityAccount,
    })
        .preInstructions([(0, exports.refreshReserveIx)(tokenInput)]);
}
function tvl(program, genericAcccounts) {
    const tokenInput = program.tokenInput;
    const portKeys = portKeysAll[tokenInput];
    const vaultKeys = program.vaultKeys[tokenInput];
    return program.methods
        .portTvl()
        .accounts({
        genericAccs: genericAcccounts,
        reserve: portKeys.reserveAccount,
        vaultPortCollateralTokenAccount: vaultKeys.vaultPortCollateralTokenAccount,
    })
        .preInstructions([(0, exports.refreshReserveIx)(tokenInput)])
        .transaction();
}
exports.tvl = tvl;
//# sourceMappingURL=port.js.map